import Discardable from '../property/discard';
import initPropertySliders from '../property/sliders';
import initPropertyMediaHandler from '../property/media';
import initMortgageCalculator from '../property/mortgage-calculator';
import initTagScrollers from '../property/tag-scroller';
import GlobalContext from '../bootstrap';
import onPopupOpenProperty from '../events/popup-open-property';
import onPopupCloseProperty from '../events/popup-close-property';
import onPopupOpenPropertyContact from '../events/popup-open-property-contact';
import { onSaveChangeHandleViewMode } from '../property/save-events';
import itemDetailMaps from '../maps/item-map';
import initPrintable from '../print';
import initPropertyEnquiryForms from '../property/enquiry';

class PropertyDetailsPage extends GlobalContext {
    constructor() {
        super();
        this._registerEvents();
        this._initialiseComponents();
    }

    _registerEvents(): void {
        window.addEventListener( 'twc:popup:open-property', onPopupOpenProperty );

        window.addEventListener( 'twc:popup:close-property', onPopupCloseProperty );

        window.addEventListener( 'twc:popup:open-property-contact', onPopupOpenPropertyContact );

        window.addEventListener( 'twc:saved-change', onSaveChangeHandleViewMode );
    }

    _initialiseComponents(): void {
        initPropertyEnquiryForms();

        new Discardable();

        initTagScrollers();

        initPropertySliders();

        initPropertyMediaHandler( document );

        initMortgageCalculator();

        itemDetailMaps();

        initPrintable();
    }
}

if ( !window.propertyPage ) {
    window.propertyPage = new PropertyDetailsPage();
}
